import styled from "styled-components";

export default styled.h2`
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: ${props => props.theme.text.heading4.size};
    color: ${props => props.theme.colours.flat.darkGray.hex};
`;
